{
  "version": 1,
  "asset_id": "3112f6bd-297c-4cb4-b0d4-0a153786e8b2",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/3112f6bd-297c-4cb4-b0d4-0a153786e8b2/libera6.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/3112f6bd-297c-4cb4-b0d4-0a153786e8b2/libera6.webp",
  "original_filename": "libera6.webp",
  "size": 47298,
  "content_type": "image/webp",
  "created_at": "2026-08-07T10:19:11Z"
}
